import { Trans } from '@lingui/react/macro';
import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

// Unknown address, or a session that failed to load for a reason other than expiry.
export const NotFoundPage = () => {
  return (
    <main className="min-h-dvh bg-background p-4 flex items-center justify-center">
      <Alert className="max-w-xl gap-y-2 border-amber-300 bg-amber-50 px-6 py-5 text-amber-900">
        <TriangleAlert className="size-10" />
        <AlertTitle>
          <h1 className="text-2xl font-semibold">
            <Trans>Session not available</Trans>
          </h1>
        </AlertTitle>
        <AlertDescription className="text-lg text-amber-800">
          <Trans>Check the link, or try again later.</Trans>
        </AlertDescription>
      </Alert>
    </main>
  );
};
